import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'

Vue.use(Vuex)

export default function createStore () {
  return new Vuex.Store({
    actions: actions,
    mutations: mutations,
    state: () => {
      return {
        api: 'https://mhk.api.siteuo.ru',
        // api: 'http://uo.localhost',
        news: null
      }
    }
  })
}
